import React, { useState, useCallback } from 'react';
import { Table, Pagination, Button, Card } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import {
  getTableHeaderClass,
  getModernDataTableClass,
  getModernCardHeaderClass,
  getModernCardBodyClass,
  getModernTableClass,
  getModernDataTableMetaClass,
} from 'utils/tableTheme';

const Cooperatives = ({ data, onRemoveButton, permission, theme }) => {

  const history = useHistory();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(40);

  const handleChangePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(Number(event.target.value));
  }, []);

  const handleRowClick = async (param) => {
    history.push(`/units/${param}`);
  }

  const totalPages = Math.ceil(data.length / rowsPerPage);
  const paginatedData = data.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

  const getPaginationRange = () => {
    const start = Math.max(page - 2, 0);
    const end = Math.min(page + 2, totalPages - 1);
    let range = [];

    for (let i = start; i <= end; i++) {
      range.push(i);
    }
    return range;
  };

  return (
    <div>
      <p className={getModernDataTableMetaClass()}>
        {data.length} registros encontrados. Página {page + 1} de {totalPages}
      </p>
      <Card className={getModernDataTableClass(theme)}>
        <Card.Header className={getModernCardHeaderClass(theme)}>Cooperativas</Card.Header>
        <Card.Body className={getModernCardBodyClass(theme)}>
          <Table
            style={{ fontSize: "0.9rem" }}
            hover
            responsive
            size="sm"
            className={getModernTableClass(theme)}
          >
            <thead>
              <tr className={getTableHeaderClass(theme)}>
                <th className="text-center col-sm-3">NOME</th>
                <th className="text-center">CNPJ</th>
                <th className="text-center">ENDEREÇO</th>
                <th className="text-center">EQUIPAMENTOS</th>
                <th className="text-center">AÇÃO</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((item) => (
                <tr
                  key={item._id}
                  className="clickable-row"
                  onClick={() => handleRowClick(item._id)}
                  style={{ cursor: 'pointer' }}
                >
                  <td className="pt-2">{item.name || '--'}</td>
                  <td className="text-center pt-2">{item.cnpj || '--'}</td>
                  <td className="text-center pt-2">
                    {item.address
                      ? item.address.length < 40
                        ? item.address
                        : `${item.address.slice(0, 40)}...`
                      : '--'}
                  </td>
                  <td className="text-center pt-2">{item.equipments?.length || '--'}</td>
                  <td className="text-center">
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={(e) => {
                        e.stopPropagation();
                        onRemoveButton(item._id);
                      }}
                      disabled={!permission}
                    >
                      Remover
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer className={`d-flex justify-content-between align-items-center ${theme === 'dark' ? 'bg-dark text-light border-secondary' : ''}`}>
          <div>
            <label>
              Linhas por página:{' '}
              <select className="modern-data-table__rows-select"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}>
                {[20, 40, 60].map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </label>
          </div>
          <Pagination className="custom-pagination" variant="dark">
            <Pagination.Prev
              onClick={() => handleChangePage(page - 1)}
              disabled={page === 0}
              aria-label="Página anterior"
            />
            {getPaginationRange().map((index) => (
              <Pagination.Item
                key={index}
                active={index === page}
                onClick={() => handleChangePage(index)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() => handleChangePage(page + 1)}
              disabled={page >= totalPages - 1}
              aria-label="Próxima página"
            />
          </Pagination>
        </Card.Footer>
      </Card>
    </div>
  );
};
export default Cooperatives;
